<template>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-md-8">
        <h1>Tantang Kami</h1>
        <div class="mt-5">
          <p style="line-height: 30px">
            PT Chakra Gahana Gemilang adalah suatu bentuk usaha di bidang
            pendistribusian dengan model penjualan dan pembelian bahan-bahan 2
            konstruksi atau pembangunan. Ada beberapa jenis bahan bangunan yang
            tersedia pada PT Chakra Gahana Gemilang seperti : besi beton, kawat,
            wiremesh, spandek, bondek, paku dan lainnya. Kegiatan yang dilakukan
            yaitu menyalurkan barang dari beberapa supplier ke beberapa toko
            besi atau toko bangunan yang ada di wilayah kab. Tangerang, Depok,
            Bogor, Bekasi, Serang, RangkasBitung, dan Pandeglang.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>